module.exports = __webpack_public_path__ + "static/media/sponsor__hyperx--white.818c09c9.png";